
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

export const AuthRequiredMessage = () => {
  const navigate = useNavigate();
  
  return (
    <Card className="border bg-card/30">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center">
          <Lock className="h-5 w-5 mr-2" />
          Требуется авторизация
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground mb-4">
          Для просмотра своих подписок необходимо авторизоваться в системе.
        </p>
        <Button 
          variant="default"
          onClick={() => navigate('/login')}
          className="w-full sm:w-auto"
        >
          Войти в систему
        </Button>
      </CardContent>
    </Card>
  );
};
